import { render, staticRenderFns } from "./wonChallenge.vue?vue&type=template&id=4897a3ff&scoped=true"
import script from "./wonChallenge.vue?vue&type=script&lang=js"
export * from "./wonChallenge.vue?vue&type=script&lang=js"
import style0 from "./wonChallenge.vue?vue&type=style&index=0&id=4897a3ff&prod&lang=scss"
import style1 from "./wonChallenge.vue?vue&type=style&index=1&id=4897a3ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897a3ff",
  null
  
)

export default component.exports